// extracted by mini-css-extract-plugin
module.exports = {"logoOutsite":"style_logoOutsite__38tIx","logo":"style_logo__12Bkb"};